// extracted by mini-css-extract-plugin
module.exports = {"promotionalTilesComponent":"jA","promotionalTile":"jB","promotionalTileThumb":"jC","promotionalTileHeader":"jD","promotionalTileCaption":"jE"};